const state = {
  isFileUpload: false,
  uploadCount: 0,
  waitUploading: null,
  resumableInfo: null
}

const getters = {
  isFileUpload: state => state.isFileUpload,
  uploadCount: state => state.uploadCount,
  waitUploading: state => state.waitUploading,
  resumableInfo: state => state.resumableInfo
}

const types = {
  setFileUpload: 'gcs/setFileUpload',
  addUploadCount: 'gcs/addUploadCount',
  setWaitUploading: 'gcs/setWaitUploading',
  setResumableInfo: 'gcs/setResumableInfo'
}

const mutations = {
  [types.setFileUpload] (state, boolean) {
    state.isFileUpload = boolean
  },
  [types.addUploadCount] (state, boolean) {
    state.uploadCount = boolean ? state.uploadCount + 1 : 0
  },
  [types.setWaitUploading] (state, data) {
    state.waitUploading = data
  },
  [types.setResumableInfo] (state, data) {
    state.resumableInfo = data
  }
}

const actions = {
  setFileUploadAction ({commit}, boolean) {
    commit(types.setFileUpload, boolean)
  },
  addUploadCountAction ({commit}, boolean) {
    commit(types.addUploadCount, boolean)
  },
  setWaitUploadingAction ({commit}, data) {
    commit(types.setWaitUploading, data)
  },
  setResumableInfoAction ({commit}, data) {
    commit(types.setResumableInfo, data)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/gcs.js